module.exports = __webpack_public_path__ + "img/mfd_in_2_title.a6ea6c7c.png";